import {
  array,
  boolean,
  check,
  custom,
  integer,
  maxLength,
  maxValue,
  minLength,
  minValue,
  nonOptional,
  number,
  object,
  optional,
  pipe,
  string
} from 'valibot';

type TranslationFunction = (key: string) => string;

export const createCourseFormSchema = (t: TranslationFunction) =>
  object({
    title: pipe(
      nonOptional(string(), t('courseForm.validation.courseTitleIsRequired')),
      minLength(1, t('courseForm.validation.courseTitleCannotBeEmpty')),
      maxLength(200, t('courseForm.validation.courseTitleCannotExceed200Characters'))
    ),
    description: pipe(
      optional(string()),
      check(
        value => !value || value.length <= 1000,
        t('courseForm.validation.descriptionCannotExceed1000Characters')
      )
    ),
    timezone: nonOptional(string(), t('courseForm.validation.timezoneRequired')),
    maxParticipants: pipe(
      nonOptional(
        pipe(
          number(),
          integer(t('courseForm.validation.maxParticipantsMustBeWholeNumber')),
          minValue(1, t('courseForm.validation.mustBeAtLeast1Participant')),
          maxValue(1000, t('courseForm.validation.cannotExceed1000Participants'))
        ),
        t('courseForm.validation.maxParticipantsRequired')
      )
    ),
    expectedParticipants: pipe(
      optional(
        pipe(
          number(),
          integer(t('courseForm.validation.expectedParticipantsMustBeWholeNumber')),
          minValue(0, t('courseForm.validation.cannotBeNegative')),
          maxValue(1000, t('courseForm.validation.cannotExceed1000Participants'))
        )
      )
    ),
    daDataCenterIds: optional(array(string())),
    daOrganizationId: pipe(
      nonOptional(number(), t('courseForm.validation.organizationRequired')),
      integer(t('courseForm.validation.organizationIdMustBeValidNumber'))
    ),
    wantToBeCoordinator: optional(boolean()),
    isDemo: optional(boolean()),
    wantToBeTrainer: optional(boolean()),
    courseDates: pipe(
      nonOptional(
        array(
          object({
            id: string(),
            startDate: string(),
            endDate: string()
          })
        ),
        t('courseForm.validation.courseDatesRequired')
      ),
      check(value => value.length > 0, t('courseForm.validation.atLeastOneCourseDateRequired')),
      check(
        value => value.length <= 50,
        t('courseForm.validation.cannotHaveMoreThan50CourseSessions')
      ),
      custom(value => {
        if (!Array.isArray(value) || value.length === 0) {
          return false;
        }

        for (const date of value) {
          if (!date || typeof date !== 'object') {
            return false;
          }
          if (!date.id || typeof date.id !== 'string') {
            return false;
          }
          if (!date.startDate || typeof date.startDate !== 'string') {
            return false;
          }
          if (!date.endDate || typeof date.endDate !== 'string') {
            return false;
          }
        }

        return true;
      }, t('courseForm.validation.invalidCourseDateStructure'))
    )
  });
